import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from './api.service';
import { TranslateService } from '@ngx-translate/core';

export interface ILanguage {
    lng_id: string;
    lng_ref: string;
    lng_libelle: string;
    lng_pay_id: string;
    lng_actif: string;
    lng_readonly: string;
}

@Injectable()
export class LanguageService {

    languages: Array<ILanguage> = [];
    currentLanguage: ILanguage;
    currentLanguageCode = 'fr';

    public currentLanguageCodeEvent: EventEmitter<any> = new EventEmitter();
    public currentLanguageEvent: EventEmitter<any> = new EventEmitter();
    public LanguagesEvent: EventEmitter<any> = new EventEmitter();

    constructor(
        private apiService: ApiService,
        private translator: TranslateService,
    ) {
        const languageCode = localStorage.getItem('language');
        if (!languageCode) {
            this.setCurrentLanguage('fr');
        } else {
            this.setCurrentLanguage(languageCode);
        }
        this.fetchLangues();
    }

    fetchLangues(): void {
        if (this.languages.length <= 0) {
            this.apiService.get(`langue`)
                .subscribe(retour => {
                    if (retour.status === 200) {
                        this.languages = retour.data.map(element => element);

                        this.initializeCurrentLangue();
                        this.LanguagesEvent.emit(this.languages);
                    }
                });
        }
    }

    initializeCurrentLangue(): void {
        const currentLanguage = this.languages.find(langue => langue.lng_ref === this.currentLanguageCode);
        if (currentLanguage) {
            this.translator.use(currentLanguage.lng_ref);
            localStorage.setItem('language', currentLanguage.lng_ref);
            this.currentLanguageCode = currentLanguage.lng_ref;
            this.currentLanguageCodeEvent.emit(currentLanguage.lng_ref);

            this.currentLanguage = currentLanguage;
            this.currentLanguageEvent.emit(currentLanguage);
            return;
        }

        // Si la langue fr n'existe pas, cherche la première langue fr-<quelque chose>
        const currentAlternativeLanguage = this.languages.find(langue => langue.lng_ref.indexOf(this.currentLanguageCode + '-') > -1 );
        if (currentAlternativeLanguage) {
            this.translator.use(currentAlternativeLanguage.lng_ref);
            localStorage.setItem('language', currentAlternativeLanguage.lng_ref);
            this.currentLanguageCode = currentAlternativeLanguage.lng_ref;
            this.currentLanguageCodeEvent.emit(currentAlternativeLanguage.lng_ref);
           
            this.currentLanguage = currentAlternativeLanguage;
            this.currentLanguageEvent.emit(currentAlternativeLanguage);
            return;
        }
    }

    getLanguages(): Array<ILanguage> {
        return this.languages;
    }

    getCurrentLangue(): ILanguage {
        return this.currentLanguage;
    }

    getCurrentLanguageCode(): string {
        return this.currentLanguageCode;
    }

    setCurrentLanguage(languageCode: string): void {
        this.translator.use(languageCode);
        localStorage.setItem('language', languageCode);
        this.currentLanguageCode = languageCode;

        this.initializeCurrentLangue();
        this.currentLanguageCodeEvent.emit(this.currentLanguageCode);
    }
}
